import { render, staticRenderFns } from "./DataTableToimeksiantoAsiakirja.vue?vue&type=template&id=89899f6c&scoped=true&"
import script from "./DataTableToimeksiantoAsiakirja.vue?vue&type=script&lang=js&"
export * from "./DataTableToimeksiantoAsiakirja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89899f6c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89899f6c')) {
      api.createRecord('89899f6c', component.options)
    } else {
      api.reload('89899f6c', component.options)
    }
    module.hot.accept("./DataTableToimeksiantoAsiakirja.vue?vue&type=template&id=89899f6c&scoped=true&", function () {
      api.rerender('89899f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataTableToimeksiantoAsiakirja.vue"
export default component.exports